import * as yup from 'yup';
import { getValidationSchema, getValidationSchema2 } from '@Shared/utils/validationSchema';
import RoutingForm1Meta from './meta/RoutingForm1Meta';
import RoutingForm2Meta from './meta/RoutingForm2Meta';
import { IRoutingModelFormMeta } from './meta/RoutingForm1Meta';

export interface IRoutingFormMeta {
  form001: IRoutingModelFormMeta,
  form002: IRoutingModelFormMeta,
  schema: any,
}

const RoutingFormMeta: IRoutingFormMeta = {} as IRoutingFormMeta;

const mainValidation = getValidationSchema(RoutingFormMeta);
const firstRoutingValidation = getValidationSchema2(RoutingForm1Meta);
const secondRoutingValidation = getValidationSchema2(RoutingForm2Meta);

const validationSchema = { 
  ...mainValidation, 
  ...firstRoutingValidation, 
  secondRoutingValidation 
};

RoutingFormMeta.form001 = RoutingForm1Meta;
RoutingFormMeta.form002 = RoutingForm2Meta;

RoutingFormMeta.schema = yup.object().shape(validationSchema);


export default RoutingFormMeta;